"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableList = void 0;
var react_1 = __importStar(require("react"));
var constants_1 = require("../../../constants");
var DraggableListItem_1 = require("./DraggableListItem");
var DraggableList = function (_a) {
    var list = _a.list, _b = _a.rowCount, rowCount = _b === void 0 ? 3 : _b, _c = _a.columnCount, columnCount = _c === void 0 ? 2 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.listItemProps, listItemProps = _e === void 0 ? {} : _e, _f = _a.itemClassName, itemClassName = _f === void 0 ? '' : _f, _g = _a.contentClassName, contentClassName = _g === void 0 ? '' : _g, id = _a.id, eventCallback = _a.eventCallback, ListItemComponent = _a.ListItemComponent, onChange = _a.onChange, _h = _a.disabled, disabled = _h === void 0 ? false : _h;
    var _j = react_1.useState(), dragStartIndex = _j[0], setDragStartIndex = _j[1];
    var handleDeleteItem = function (index) {
        var copyListItems = __spreadArray([], list);
        copyListItems.splice(index, 1);
        onChange(copyListItems);
    };
    var handleListItemChange = function (index, value) {
        var copyListItems = __spreadArray([], list);
        copyListItems[index] = value;
        onChange(copyListItems);
    };
    var handleDragStart = function (index) {
        setDragStartIndex(index);
    };
    var handleDragEnter = function (index) {
        if (dragStartIndex !== index) {
            setDragStartIndex(index);
            var copyListItems = __spreadArray([], list);
            var dragItem = copyListItems[dragStartIndex !== null && dragStartIndex !== void 0 ? dragStartIndex : 0];
            copyListItems.splice(dragStartIndex !== null && dragStartIndex !== void 0 ? dragStartIndex : 0, 1);
            copyListItems.splice(index, 0, dragItem);
            onChange(copyListItems);
        }
    };
    return (react_1.default.createElement("div", { className: "tw-flex tw-flex-col tw-gap-6 " + className, "data-testid": "draggable-list-" + id }, list.map(function (item, index) { return (react_1.default.createElement(DraggableListItem_1.DraggableListItem, { key: "DRAGGABLE_LIST_ITEM_" + index, item: item, index: index, onDragStart: disabled ? constants_1.defaultFn : handleDragStart, onDragEnter: disabled ? constants_1.defaultFn : handleDragEnter, itemClassName: itemClassName, contentClassName: contentClassName, rowCount: disabled ? 0 : rowCount, listItemProps: listItemProps, columnCount: disabled ? 0 : columnCount, ListItemComponent: ListItemComponent, id: id, eventCallback: eventCallback, onChange: function (value) { return handleListItemChange(index, value); }, onDelete: function () { return handleDeleteItem(index); }, showDelete: list.length > 1, disabled: disabled })); })));
};
exports.DraggableList = DraggableList;
